export enum NonEssentialVendors {
  WOOTRIC = "Wootric",
  FEATURE_FEEDBACK_COLLECTOR = "Feature Feedback Collector",
  INTERCOM = "Intercom",
}

export type PartyType = "First Party" | "Third Party";

/** Canonical policy keys sent to (and returned by) the Access Cookie Policies SDK. */
export const ESSENTIAL_POLICY = "essential";
export const ANALYTICS_POLICY = "analytics";

export interface VendorEntry {
  name: string;
  key?: string;
  description: string;
  vendorUrl: string;
  partyType: PartyType;
}

export interface PolicyCategory {
  policyName: string;
  vendors: VendorEntry[];
}

export interface VendorCatalog {
  essential: PolicyCategory;
  analytics: PolicyCategory;
}

export interface CookieConsentState {
  [policyName: string]: boolean;
}

export interface CookieConsentResult {
  consent: CookieConsentState;
  isGranted: (policyName: string) => boolean;
}

/** Vendor definition as declared to the SDK inside a party entry. */
export interface SdkVendorDefinition {
  name: string;
  key: string;
  description: string;
  vendorUrl: string;
  partyType: PartyType;
}

/** Party entry as declared to the SDK: one policy with its vendors. */
export interface SdkPartyDefinition {
  policy: string;
  vendors: SdkVendorDefinition[];
}

export interface SdkConsentEntry {
  policy: string;
  vendors: string[];
}

/**
 * Consent as returned by the SDK: `"*"` for everything granted, `null` for
 * essential only, or the list of granted policies.
 */
export type SdkConsent = "*" | null | SdkConsentEntry[];

/** Raw product-consent object returned by `tabInitialise`. */
export interface SdkProductConsent {
  pid: string;
  consent: SdkConsent;
  policyVersion: string;
}

export interface AccessCookiePoliciesSDK {
  tabInitialise: (options: {
    config: {
      policies: string[];
      parties: SdkPartyDefinition[];
      applicationId: string;
      policyVersion: string;
      policyUrl: string;
    };
    language: string;
  }) => Promise<SdkProductConsent>;
}

declare global {
  interface Window {
    AccessCookiePolicies?: {
      SDK?: AccessCookiePoliciesSDK;
    };
  }
}
